import axios from "axios";

import { SHS_ADMIN_BASE_URL } from "./constants.js";

const UPDATE_STUDENT_DATA_URL = `${SHS_ADMIN_BASE_URL}/student/add`;

export default async function addNewStudent({
  jhsIndexNumber,
  admissionYear,
  name,
  gender,
  programOffered,
  track,
  residentialStatus,
  lastSchoolAttended,
  grade,
  score,
  enrolmentCode,
  schoolId,
}) {
  try {
    const { data: result } = await axios({
      url: UPDATE_STUDENT_DATA_URL,
      method: "post",
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        jhsIndexNumber,
        admissionYear,
        name,
        gender,
        programOffered,
        track,
        residentialStatus,
        lastSchoolAttended,
        grade,
        score,
        enrolmentCode,
        schoolId,
      },
    });

    return result;
  } catch (error) {
    throw error;
  }
}
